import { useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { ShoppingBag, Mail } from 'lucide-react';
import api from '../lib/api';

export default function VerifyEmailPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email || '';
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleVerify = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    setLoading(true);
    try {
      await api.post('/auth/verify-email', { email, code });
      setSuccess('Email verificado com sucesso!');
      setTimeout(() => navigate('/'), 1500);
    } catch (err) {
      setError(err.response?.data?.detail || 'Código inválido');
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    try {
      await api.post('/auth/resend-code', { email });
      setSuccess('Código reenviado!');
    } catch {
      setError('Erro ao reenviar código');
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-sm text-center">
        <div className="mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-4">
            <Mail className="h-8 w-8 text-primary" />
          </div>
          <h1 className="text-2xl font-bold tracking-tight" style={{ fontFamily: 'Outfit' }}>Verificar Email</h1>
          <p className="text-sm text-muted-foreground mt-2">
            Enviamos um código de 6 dígitos para<br /><strong>{email}</strong>
          </p>
        </div>

        <form onSubmit={handleVerify} className="space-y-4" data-testid="verify-email-form">
          {error && <div className="p-3 rounded-lg bg-destructive/10 text-destructive text-sm">{error}</div>}
          {success && <div className="p-3 rounded-lg bg-primary/10 text-primary text-sm">{success}</div>}
          <div className="space-y-2">
            <Label>Código de verificação</Label>
            <Input
              type="text"
              placeholder="000000"
              value={code}
              onChange={e => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
              className="text-center text-2xl tracking-[0.5em] font-mono"
              maxLength={6}
              required
              data-testid="verify-code-input"
            />
          </div>
          <Button type="submit" className="w-full rounded-lg" disabled={loading || code.length !== 6} data-testid="verify-submit-btn">
            {loading ? 'Verificando...' : 'Verificar'}
          </Button>
        </form>

        <button onClick={handleResend} className="text-sm text-primary hover:underline mt-4" data-testid="resend-code-btn">
          Reenviar código
        </button>
        <div className="mt-4">
          <Link to="/" className="text-sm text-muted-foreground hover:underline">Pular por enquanto</Link>
        </div>
      </div>
    </div>
  );
}
